import { AgTechClickEventHandler, AgTechButtonProps, AgTechButton } from '@agtech/web/components/Buttons/AgTechButtons'
import React from 'react'
import { useSaleContactDataGetContactDetailsQuery } from '@sales/data/operation/contacts/SaleContactDataQueries'
import { getSaleContactDetailTabPageProps } from '../../pages/SaleContactDetailsTabPage'
import AgTechModernTabPage from '@agtech/web/components/Pages/Tabbed/Flavors/AgTechModernTabPage'
import AgTechQueryLoadingSurface from '@agtech/core/data/queries/AgTechQueryLoadingSurface'
import { SaleContactRemovalButton } from '../../components/buttons/SaleContactButtons'
import ContactMasterDetailViewDialog from '@agtech/web/integrations/contacts/dialogs/ContactMasterDetailViewDialog'
import { getContactFullName } from '@agtech/data/contacts/ContactData'
import ContactDialog from '@agtech/web/integrations/contacts/dialogs/ContactDialog'

const SaleContactMasterDetailDialog = () => {
    return (
        <ContactMasterDetailViewDialog
            contactDetailPage={contact => <SaleContactMasterDetailPage contactId={contact.id} />}
        />
    )
}

const SaleContactMasterDetailPage = (props: { contactId: number }) => {
    const contactDetailsQuery = useSaleContactDataGetContactDetailsQuery(props.contactId);
    
    return (
        <AgTechQueryLoadingSurface query={contactDetailsQuery}>
            {(contactDetails) => {
                const tabProps = getSaleContactDetailTabPageProps({ contactDetails });

                return (
                    <AgTechModernTabPage
                        title={getContactFullName(contactDetails.contact)}
                        {...tabProps}
                        header={{
                            ...tabProps.header,
                            content: () => (
                                <div className='column-based gap-x-3 flex'>
                                    <ContactDialog.Button
                                        text='Update'
                                        contactId={contactDetails.contact.id}
                                    />
                                    <SaleContactRemovalButton
                                        contact={contactDetails.contact}
                                        text='Delete'
                                    />
                                </div>
                            )
                        }}
                    />
                )
            }}
        </AgTechQueryLoadingSurface>
    )
}

SaleContactMasterDetailDialog.ButtonProps = (props?: AgTechButtonProps) => ({
    text: 'Manage contacts',
    icon: 'fas fa-address-book',
    ...props,
    action: (e: AgTechClickEventHandler) => e.dialogs.openDialog({
        dialog: () => <SaleContactMasterDetailDialog />
    })
})

SaleContactMasterDetailDialog.Button = (props: AgTechButtonProps) => {
    return (
        <AgTechButton {...SaleContactMasterDetailDialog.ButtonProps(props)} />
    )
}

export default SaleContactMasterDetailDialog